import { StyledOrderedListItem } from "ui-library/Styled";

// podla variantu pridaj ikonku

export const ListItem = ({ children, ...props }) => {
    return <StyledOrderedListItem {...props}>{children}</StyledOrderedListItem>;
};
